import { Dispatch, SetStateAction, useState } from "react";
import { useForm } from "react-hook-form";
import { Contacto, CreateContactoRequest } from "../../types/empresa";
import { SaveButton } from "../UtilitiesComponents/SaveButton";
import { CancelButton } from "../UtilitiesComponents/CancelButton";
import { InputDatosGenerales } from "../UtilitiesComponents/InputDatosGenerales";
import { useUpdateContactoMutation } from "../../api/empresa/empresaApi";
import { CircularProgress } from "@mui/joy";
import { ErrorMessage } from "../UtilitiesComponents/ErrorMessage";
import { getErrorMessage } from "../../utils/errorHelpers";
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import WorkRoundedIcon from '@mui/icons-material/WorkRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import PhoneAndroidRoundedIcon from '@mui/icons-material/PhoneAndroidRounded';
import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';

interface Props {
    empresaId: number;
    contacto: Contacto;
    setShowEdit: Dispatch<SetStateAction<boolean>>;
    showEdit: boolean;
}

export function EditContactoInfo({ contacto, setShowEdit, showEdit, empresaId }: Props) {
    const [updateContacto, { isLoading }] = useUpdateContactoMutation();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const iconSize = 20;

    const {
        register,
        handleSubmit,
        formState: {
            isDirty,
            errors,
        },
    } = useForm<Contacto>({
        defaultValues: contacto,
    });

    const submitUpdate = handleSubmit(async (data: Contacto) => {
        try {
            const request: CreateContactoRequest = {
                empresaId: empresaId,
                contactoInfo: data
            }
            console.log(request , "hola")

            await updateContacto(request).unwrap();

            setShowEdit(false);
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }) 

    return (
        <div>
            <form onSubmit={submitUpdate} autoComplete="off">
                <InputDatosGenerales
                    icon={<Person2RoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Nombre"}
                    register={register("nombre", {
                        required: "El nombre es requerido",
                        maxLength: 50,
                    })}/>
                {errors.nombre?.type === "required" && (
                    <p className="valErrorText text-sm">{errors.nombre.message}</p>
                )}
                {errors.nombre?.type === "maxLength" && (
                    <p className="valErrorText text-sm">{"Maximo de caracteres: 50"}</p>
                )}

                <InputDatosGenerales
                    icon={<WorkRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Puesto"}
                    register={register("puesto", {
                        required: "El puesto es requerido",
                        maxLength: 30,
                    })}/>
                {errors.puesto?.type === "required" && (
                    <p className="valErrorText text-sm">{errors.puesto.message}</p>
                )}
                {errors.puesto?.type === "maxLength" && (
                    <p className="valErrorText text-sm">{"Maximo de caracteres: 30"}</p>
                )}

                <InputDatosGenerales
                    icon={<EmailRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Correo"}
                    register={register("correo", {
                        required: "El correo es requerido",
                        maxLength: 30,
                    })}/>
                {errors.correo?.type === "required" && (
                    <p className="valErrorText text-sm">{errors.correo.message}</p>
                )}
                {errors.correo?.type === "maxLength" && (
                    <p className="valErrorText text-sm">{"Maximo de caracteres: 30"}</p>
                )}

                <InputDatosGenerales
                    icon={<LocalPhoneRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Telefono empresa"}
                    register={register("telefonoEmpresa", {
                        maxLength: 10,
                    })}/>
                {errors.telefonoEmpresa?.type === "maxLength" && (
                    <p className="valErrorText text-sm">{"Maximo de caracteres: 10"}</p>
                )}

                <InputDatosGenerales
                    icon={<PhoneAndroidRoundedIcon sx={{ height: iconSize, width: iconSize }}/>}
                    label={"Telefono personal"}
                    register={register("telefonoPersonal", {
                        maxLength: 10,
                    })}/>
                {errors.telefonoPersonal?.type === "maxLength" && (
                    <p className="valErrorText text-sm">{"Maximo de caracteres: 10"}</p>
                )}

                <div className="w-full mb-[11px]">
                    <div className="flex items-center gap-x-2">
                        <ArticleRoundedIcon sx={{ height: iconSize, width: iconSize }}/>
                        <label className="font-semibold min-w-[140px]">Comentarios</label>
                    </div>
                    <textarea
                        {...register("comentarios")}
                        className="
                            w-full h-[100px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm resize-none">
                    </textarea>
                </div>

                {errorMessage && (
                    <div className="my-2">
                        <ErrorMessage
                            customMessage>
                            <p className="text-sm">{errorMessage}</p>
                        </ErrorMessage>
                    </div>
                )}

                <div className="flex justify-center gap-x-4">
                    {isLoading
                    ? 
                    <div className="w-[27px] h-[27px] flex items-center justify-center">
                        <CircularProgress sx={{
                            "--CircularProgress-progressThickness": "4px",
                            "--CircularProgress-trackThickness": "4px",
                            "--CircularProgress-size": "25px"
                        }}/>
                    </div>
                    : 
                    <>
                    <SaveButton
                        disabled={!isDirty}
                        text="Actualizar"
                        type="submit"/>

                    <CancelButton
                        onClick={()=> {
                            setShowEdit(false);
                        }}/>
                    </>
                    }
                </div>
            </form>
        </div>
    );
}